import { memo, useCallback, useContext, useState } from 'react';
import cn from 'classnames';

import { Button } from 'UIPackage/MainModule/components/Button';
import { KnmAttachmentsSigning } from 'KnmPackage/MainModule/components/KnmAttachmentsSigning';
import { IKnmAttachment } from 'APIPackage/KnmModule/interfaces/IKnmAttachment';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { IDecisionFormRef } from 'DecisionPackage/MainModule/interfaces/IDecisionFormRef';
import { getTitleFieldWithRedStar } from 'functions/getTitleFieldWithRedStar';
import { AgreementsContext } from 'KnmErknmPackage/ErkmAgreementsModule/AgreementsContext';

import styles from './AgreementsEliminateViolationsAttachment.module.scss';
import { FileButtonErrorMessage } from '../FileButtonErrorMessage/FileButtonErrorMessage';

interface IAgreementsEliminateViolationsAttachmentProps {
  attachment: IKnmAttachment[] | null | undefined;
  formRef?: IKnmFormRef | IDecisionFormRef;
  id: string;
  isWatchOnly: boolean;
  name: string;
}

export const AgreementsEliminateViolationsAttachment = memo(
  ({ attachment, formRef, id, isWatchOnly, name }: IAgreementsEliminateViolationsAttachmentProps) => {
    const [isVisibleSignModal, setIsVisibleSignModal] = useState<boolean>(false);
    const { isKnm, isPm, isDecision } = useContext(AgreementsContext);

    const openSignModal = useCallback(() => setIsVisibleSignModal(true), []);
    const closeSignModal = useCallback(() => setIsVisibleSignModal(false), []);

    return (
      <div className={styles.ActDocument} id={id}>
        {(!attachment || attachment.length === 0) && (
          <>
            <Button
              className={cn('shared-btn-add', styles.ActDocumentAddButton)}
              text={getTitleFieldWithRedStar({
                label: `Добавить файл соглашения`,
                field: name,
                isKnm,
                isPm,
                isDecision,
              })}
              variant="link"
              color="primary"
              type="button"
              id="fileAddButton"
              disabled={isWatchOnly}
              onClick={openSignModal}
            />
            <FileButtonErrorMessage name={name} />
          </>
        )}

        <FieldBlock
          label={!!attachment && attachment.length > 0 && 'Файл соглашения'}
          color="black"
          placementLabel="left"
          type="not-space"
          className={styles.FieldBlock}
        >
          <KnmAttachmentsSigning
            acceptedFiles=".pdf"
            isWatchOnly={isWatchOnly}
            name={name}
            isVisibleSignModal={isVisibleSignModal}
            closeSignModal={closeSignModal}
            formRef={formRef}
          />
        </FieldBlock>
      </div>
    );
  },
);
